import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { fetchReportRole } from "services/reportRole";

const ReportRolesDropDown = ({
    errors,
    control,
    setValue,
    getValues,
    watch,
    rowData,
    required,
}) => {
    const reportName =
        rowData?.report_obj?.role_name ||
        rowData?.role_name ||
        getValues()?.role_name;

    const reportId =
        rowData?.report_obj?.id ||
        rowData?.id ||
        getValues()?.id;

    const selectedReport = watch("role_id");

    const { data, isLoading, error } = useQuery(
        ["report-role-dropdown"],
        fetchReportRole,
        {
            keepPreviousData: false,
            staleTime: DROPDOWN_STALE_TIME,
        }
    );

    const options = useMemo(() => {
        return (
            data?.data?.data?.map((report) => ({
                value: report.id,
                label: report.role_name,
            })) || []
        );
    }, [data]);

    const selectedOption = useMemo(() => {
        return (
            options.find((option) => option.value === selectedReport) ||
            options.find((option) => option.value === reportId) ||
            options.find((option) => option.label === reportName) ||
            null
        );
    }, [options, selectedReport, reportId, reportName]);

    useEffect(() => {
        if (rowData && options.length) {
            const rowDataOption = options.find(
                (option) => option.value === rowData?.id
            );
            if (rowDataOption) {
                setValue("role_id", rowDataOption.value);
                setValue("role_name", rowDataOption.label);
            }
        }
    }, [rowData, options, setValue]);

    if (isLoading) return <div>Loading...</div>;
    if (error) return <div>Error loading Reports</div>;

    return (
        <Controller
            name="role_id"
            control={control}
            rules={{
                required: required ? "Report is required" : false,
                validate: (value) => {
                    if (required && !value) return "Report is required";
                    return true;
                },
            }}
            render={({ field }) => (
                <Select
                    {...field}
                    options={options}
                    isClearable
                    value={selectedOption}
                    placeholder="Select Report"
                    menuPortalTarget={document.body}
                    styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    onChange={(selectedOption) => {
                        const value = selectedOption ? selectedOption.value : "";
                        field.onChange(value);
                        setValue("role_id", value);
                        setValue("role_name", selectedOption ? selectedOption.label : "");
                    }}
                    className={`react-select-container ${errors.role_id ? "is-invalid" : ""
                        }`}
                />
            )}
        />
    );
};

export default ReportRolesDropDown;
